import React from 'react'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import styles from './PatientPendingMessage.css'
import FormattedDate from '../../components/FormattedDate'
import FormatConnectionCode from '../../components/FormatConnectionCode'
import PendingIcon from 'static/images/pending.svg'
import { getDateFormat } from '../../../common/dateUtils'

export const PatientPendingMessage = props => {
  const { currentEnrollment, codes, me } = props

  const pendingCode =
    currentEnrollment &&
    codes &&
    codes.find(c => c.code === currentEnrollment.connection_code)
  const code = pendingCode && pendingCode.code
  const createdAt = pendingCode && pendingCode.createdAt

  const todayOrYestGrammar = date => {
    const diff = moment().diff(date, 'days')
    return diff === 0 || diff === 1 ? '' : <FormattedMessage id="todayOrYestGrammar.on" />
  }

  return (
    <div className={styles.pendingMessage}>
      {(currentEnrollment.status.toLowerCase() === 'pending' ||
        currentEnrollment.status.toLowerCase() === 'enrolled') && (
        <PendingIcon />
      )}
      <div className={styles.copy}>
        <div className={styles.message}>
          <div>
            <FormattedMessage
              id="information.connection_info.patientPendingMessage"
              values={{
                createdAt: todayOrYestGrammar(createdAt),
              }}
            />{' '}
            <span className={styles.bold}>
              <FormattedDate date={createdAt} fmt={getDateFormat(me)} me={me} />
            </span>
            ,
          </div>
          {(currentEnrollment.status === 'pending' ||
            currentEnrollment.status === 'enrolled') && (
            <div>
              <FormattedMessage id="information.connection_info.patientPendingStatus" />
            </div>
          )}
        </div>
        <div className={styles.label}>
          <FormattedMessage id="label.Referral_Code" />:
          <span className={styles.code}>
            <FormatConnectionCode code={code} />
          </span>
        </div>
      </div>
    </div>
  )
}

export default PatientPendingMessage



// WEBPACK FOOTER //
// ./src/legacy/components/PatientPendingMessage/PatientPendingMessage.jsx